import service from "@/utils/request"

/**
 * 获取订单列表
 */
export function queryOrderPageApi(params) {
    return service({
        url: "/offline/order/getPage",
        method: "get",
        params
    })
}

/**
 * 获取 待使用、售后、待开票计数
 */
export function getAllTagCountApi(params) {
    return service({
        url: "/offline/order/getAllTagCount",
        method: "get",
        params
    })
}

/**
 * 线下服务开发票
 */
export function writeAReceiptApi(data) {
    return service({
        url: "/offline/order/writeAReceipt",
        method: "post",
        data
    })
}


export function offlineOrderVerifyApi(data) {
    return service({
        url: '/offline/order/verifyOrder',
        method: 'post',
        data
    })
}

export function offlineOrderCancelApi(data) {
    return service({
        url: '/offline/order/cancel',
        method: 'post',
        data
    })
}

export function offlineExportOrderApi(data) {
    return service({
        url: '/offline/order/excel',
        method: 'get',
        params:data,
        responseType: 'blob',
    })
}